module.exports = __webpack_public_path__ + "static/dl1-banner-dfb5d437c2e0cc645077a050c28bd084.jpg";